import React from 'react'
import ResumeCheckbox from '../ResumeCheckbox'
import { connect } from "react-redux";
import { handlePublicationPrivacy } from '../../../../services/actions/actions';

function ContentPublication({ publicationDetail,handlePublicationPrivacy }) {
    return (
        <>
            <div>
                {publicationDetail.map((data, idx) => {
                    const {entries,isHidden}  = data;
                    return <div key={idx} className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>{entries.title} - </span>
                            <span className='text-sm italic manpro text-gray-600 font-light'>{entries.publishers}</span>
                        </div>
                        <div>
                            <ResumeCheckbox value={isHidden ? 'noshow' : 'show'} onChange={(e) => handlePublicationPrivacy({selectedId: idx, value: e.target.value})}/>
                        </div>
                    </div>
                })}
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handlePublicationPrivacy: (value) => {
            dispatch(handlePublicationPrivacy(value))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(ContentPublication)
